import { render, staticRenderFns } from "./DaysToComplete.vue?vue&type=template&id=a8477d5c&"
import script from "./DaysToComplete.vue?vue&type=script&lang=js&"
export * from "./DaysToComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports